import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { JardinModel } from 'src/app/model/Jardin.model';
import { InicioTutorComponent } from '../../inicio-tutor.component';

@Component({
  selector: 'app-simulacion-jardin',
  templateUrl: './simulacion-jardin.component.html',
  styleUrls: ['./simulacion-jardin.component.css']
})
export class SimulacionJardinComponent implements OnInit {


  @Input()jardin: JardinModel;
  @ViewChild('divSpinner') divSpinner:ElementRef;
  cargando = true;

  constructor(
    @Inject(InicioTutorComponent) private parent: InicioTutorComponent
  ) { }

  ngOnInit(): void {
    this.cargando = false;
  }



  volver(){
    this.parent.ngOnInit();

  }

}
